import React, { useEffect, useState } from "react";
import { KTSVG } from "../../../../_metronic/helpers";
import { Modal } from "react-bootstrap-v5";
import { useHistory } from "react-router-dom";
import { defaultProfileImage } from "../../../utils/constants";
import { showErrorAlert } from "../../../helpers/alert";
import { ExperiencesList } from "./ExperiencesList";
import { formatPhone } from "../../../helpers/FormatInputs";
import { getExperiencesByUser } from "../../../services/profileAdminService";

type Props = {
    open: boolean;
    partner: any;
    onClose: (close: boolean) => void;
    onEdit: (id:number) => void;
};

const DetailPartnerDrawer:React.FC<Props> = ({ open, onClose, partner, onEdit }) => {
    const history = useHistory()
    const [activeTab, setActiveTab] = useState(1)
    const [partnerExperiences, setPartnerExperiences] = useState<any[]>([])

    useEffect(() => {
        const fetchPartnerExperiences = async () => {
            const partnerUserId = partner?.user || partner?.userId || partner?.user_id || partner?.id;
            if (partnerUserId && open) {
                try {
                    const data = await getExperiencesByUser(partnerUserId);
                    const items = Array.isArray(data) ? data : (data?.results ?? []);
                    setPartnerExperiences(items);
                } catch (err) {
                    setPartnerExperiences([]);
                }
            }
        };
        fetchPartnerExperiences();
    }, [partner, open, activeTab]);

    const handleCancel = () => {
        onClose(false);
    }

    const handleEdit = () => {
        onClose(false)
        onEdit(partner.id)
    }

    const handleChangeTab = async (tab:number) => {
        setActiveTab(tab);
    }

    return (<Modal show={open} 
        onHide={handleCancel}
        backdrop='static'
        dialogClassName='experience-detail-modal w-drawer-partner'
        contentClassName='experience-detail-content'
        backdropClassName='experience-detail-backdrop'
        className={`w-100`}>
        <div className={`admin-experience-details-container`}>
            {/* Header */}
            <div className="admin-experience-details-header">
                <h2 className="admin-experience-details-title">
                    Agency Detail
                </h2>
                <div className="rm-style-3 cursor-pointer" onClick={()=>onClose(false)}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>

            {/* Action */}
            <div className="admin-experience-details-action">
                <div className='tab-navigation w-100'>
                    <div className='d-flex flex-row'>
                        <div className={`tab-navigation__item ${activeTab === 1 ? 'tab-navigation__item--selected' : ''}`}
                        onClick={()=>handleChangeTab(1)}>
                            <div className='tab-navigation__label'>General Profile</div>
                        </div>
                        <li className={`separator-vertical d-flex`}>
                            <hr />
                        </li>
                    </div>
                    <div className='d-flex flex-row'>
                        <div className={`tab-navigation__item ${activeTab === 2 ? 'tab-navigation__item--selected' : ''}`}
                        onClick={()=>handleChangeTab(2)}>
                            <div className='tab-navigation__label'>Activity</div>
                        </div>
                    </div>
                </div>
                <div className='tab-navigation w-100 gap-3 justify-content-end'>
                    <button className="tap-add-experience-2-btn-secondary" onClick={()=>showErrorAlert({title:'',message:'coming soon'}) }>
                        <KTSVG path='/media/svg/nobilis/calendar-edit.svg' />&nbsp;
                        <span>Create record</span>
                    </button>
                    <div className="tap-add-experience-2-btn-main" role="button" onClick={handleEdit}>
                        <div className="tap-host-button-text tap-flex-center">
                            Edit
                            &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                        </div>
                    </div>
                </div>
            </div>

            {/* detail company */}
            <div className={`admin-experience-details-card ${activeTab === 1 ? 'd-flex' : 'd-none'}`}>
                <div className="admin-experience-details-user">
                    <div className="admin-experience-details-id d-flex flex-row">
                        <div className="w-50"># {partner?.id}</div>
                        {/* <div className="w-50 text-end">{EXPERIENCE_STATUS_LIST.map((item)=>item.id == partner.status ? (item.name) : null)}</div> */}
                    </div>

                    <div className="admin-experience-details-user-info">
                        <img className="admin-experience-details-avatar" src={partner?.logo || defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                        <span className="admin-experience-details-value fw-bold">
                            {partner?.companyName}
                        </span>
                    </div>
                </div>

                <div className="admin-experience-details-contact">
                    <div className="admin-experience-details-field">
                        <span className="admin-experience-details-value">
                            {partner?.description}
                        </span>
                    </div>
                </div>
                <div className="admin-experience-details-contact w-100">
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Location</span>
                        <span className="admin-experience-details-value">
                            {partner?.address ?? 'N/A'}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Email</span>
                        <span className="admin-experience-details-value">
                            {partner?.emailCompany ?? 'N/A'}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Phone</span>
                        <span className="admin-experience-details-value">
                            {formatPhone(partner?.phoneNumber)}
                        </span>
                    </div>
                </div>
            </div>

            {/* Section contact */}
            <div className={`admin-experience-details-summary ${activeTab === 1 ? 'd-flex' : 'd-none'}`}>
                <div className="admin-experience-details-summary-header">
                    <h4 className="admin-experience-details-summary-title">
                        EMPLOYEES DETAILS
                    </h4>
                </div>

                <div className="admin-experience-details-contact w-100">
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Name</span>
                        <span className="admin-experience-details-value">
                            {partner?.contactName ?? 'N/A'}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Email</span>
                        <span className="admin-experience-details-value">
                            {partner?.contactEmail ?? 'N/A'}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Phone</span>
                        <span className="admin-experience-details-value">
                            {formatPhone(partner?.contactPhone)}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Rol</span>
                        <span className="admin-experience-details-value">
                            {partner?.contactRole ?? 'N/A'}
                        </span>
                    </div>
                    <div className="admin-experience-details-field w-100">
                        <span className="admin-experience-details-label">Estatus</span>
                        <span className="admin-experience-details-value">
                            {partner?.status ?? 'N/A'}
                        </span>
                    </div>
                </div>
            </div>
            
            {/* Section payment */}
            <div className={`admin-experience-details-summary  ${activeTab === 1 ? 'd-flex' : 'd-none'}`}>
                <div className="admin-experience-details-summary-header">
                    <h4 className="admin-experience-details-summary-title">
                        PAYMENT METHOD
                    </h4>
                </div>

                {partner?.bankAccount?.length > 0 ? (
                    partner?.bankAccount.map((bankaccount:any)=>(<div className="tap-add-experience-2-category-pill tap-add-experience-2-category-pill--selected align-items-start">
                            <div className="d-flex flex-row mt-2">
                                <div className="admin-experience-details-summary p-3 pt-0 pb-2">
                                    <KTSVG path="/media/svg/nobilis/bank.svg" />
                                </div>
                            </div>
                        <div className="admin-experience-details-field w-100">
                            <span className="admin-experience-details-value fw-normal">{bankaccount?.bankName}</span>
                            <span className="admin-experience-details-value">
                                {bankaccount?.beneficiary}
                            </span>
                            <span className="partners-detail-bank-account-info">Bank Account: {bankaccount?.iban}</span>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="partners-detail-bank-account-swift-code">SWIFT CODE: {bankaccount?.swiftCode}</span>
                                <span className="partners-detail-bank-account-primary">{bankaccount?.isPrimary ? 'Primary' : ''}</span>
                            </div>
                        </div>
                    </div>))
                    ) : null
                }
            </div>
            
            <div className={`w-100  ${activeTab === 2 ? 'd-flex' : 'd-none'}`}>
                <ExperiencesList data={partnerExperiences}  />
            </div>
        </div>

    </Modal>);
}

export { DetailPartnerDrawer }